var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper"},[_c('h6',{staticClass:"q-pa-none q-my-none"},[_vm._v(" Permissions ")]),_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[(item.condition)?_c('slider-item',{attrs:{"item":item}}):_vm._e()],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }